// extracted by mini-css-extract-plugin
export default {"section":"Areas_section__Tcffy","inner":"Areas_inner__dxM2G","kicker":"Areas_kicker__uwLcy","grid":"Areas_grid__H0GUs","card":"Areas_card__F29iy","icon":"Areas_icon__kKwvx"};